import { buildTemplateEntryHref } from '@/lib/routing/template-entry';

export type MerchantImagePageKey = 'whiteBackground' | 'ecommerce';

export const ECOMMERCE_IMAGE_CASE = {
  date: '2026-09-06',
  durationSeconds: 71,
  credits: 1556,
  outputCount: 4,
} as const;

export const MERCHANT_IMAGE_PAGES = {
  whiteBackground: {
    path: '/white-background-product-photography',
    capability: 'whiteBackground',
    templateId: '85a30854-0450-4555-a888-53c7184a24a3',
    images: [
      { src: '/media-previews/v1/effects/white-background-input.jpg', width: 490, height: 960 },
      { src: '/media-previews/v1/effects/white-background-output.jpg', width: 714, height: 960 },
    ],
  },
  ecommerce: {
    path: '/ai-ecommerce-image-generator',
    capability: 'productDetail',
    templateId: 'b2f8c1d4-9a36-4e7c-bf21-0d4a6c93e518',
    images: [
      { src: 'https://media.dobidobi.ai/platform-assets/1788607839514_1947e510.jpg', width: 586, height: 879 },
      { src: 'https://media.dobidobi.ai/ai_generated/product-suites/5ab124c0-8f5e-4a3c-a534-97097026cb33/0.png', width: 1080, height: 1440 },
      { src: 'https://media.dobidobi.ai/ai_generated/product-suites/5ab124c0-8f5e-4a3c-a534-97097026cb33/1.png', width: 1080, height: 1440 },
      { src: 'https://media.dobidobi.ai/ai_generated/product-suites/5ab124c0-8f5e-4a3c-a534-97097026cb33/2.png', width: 1080, height: 1440 },
      { src: 'https://media.dobidobi.ai/ai_generated/product-suites/5ab124c0-8f5e-4a3c-a534-97097026cb33/3.png', width: 1080, height: 1440 },
    ],
  },
} as const;

export function buildMerchantImageStartHref(pageKey: MerchantImagePageKey, locale: import('@/i18n/locales').Locale) {
  const page = MERCHANT_IMAGE_PAGES[pageKey];
  return buildTemplateEntryHref(page.templateId, { locale, sourceLanding: page.path });
}
